import { render, staticRenderFns } from "./UploadedImage.vue?vue&type=template&id=36f41a9a"
import script from "./UploadedImage.vue?vue&type=script&lang=js"
export * from "./UploadedImage.vue?vue&type=script&lang=js"
import style0 from "./UploadedImage.vue?vue&type=style&index=0&id=36f41a9a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports